import BautismoAlba from "./BautismoAlba";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "bautismo-alba",
  tipoEvento: "bautismo",
  tipoEtiqueta: "Bautismo",
  nombre: "Alba",
  descripcion:
    "Ternura luminosa para bautismos: nombre en caligrafía, fotografía en arco bautismal, paloma con rama de olivo en SVG y paletas suaves de cielo, pétalo y lino.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    cielo: "/miniaturas/bautismo-alba-cielo.jpg",
    petalo: "/miniaturas/bautismo-alba-petalo.jpg",
    lino: "/miniaturas/bautismo-alba-lino.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: BautismoAlba,
};
